import wedding1 from './/Wedding1.jpg';
import wedding2 from './/Wedding2.jpg';
import wedding3 from './/Wedding3.jpg';
import wedding4 from './/Wedding4.jpg';
import wedding5 from './/Wedding5.jpg';
import wedding6 from './/Wedding6.jpg';
import wedding7 from './/Wedding7.jpg';
import wedding8 from './/Wedding8.jpg';
import wedding9 from './/Wedding9.jpg';
import wedding10 from './/Wedding10.jpg';
import wedding11 from './/Wedding11.jpg';
import wedding12 from './/Wedding12.jpg';
import wedding13 from './/Wedding13.jpg';
import wedding14 from './/Wedding14.jpg';
import wedding15 from './/Wedding15.jpg';
import wedding16 from './/Wedding16.jpg';
import wedding17 from './/Wedding17.jpeg';
import wedding18 from './/Wedding18.jpeg';
import wedding19 from './/Wedding19.jpeg';
import wedding20 from './/Wedding20.jpeg';
import wedding21 from './/Wedding21.jpeg';
import wedding22 from './/Wedding22.jpeg';
import wedding23 from './/Wedding23.jpeg';
import wedding24 from './/Wedding24.jpeg';
import wedding25 from './/Wedding25.jpeg';
import wedding26 from './/Wedding26.jpeg';
import wedding27 from './/Wedding27.jpg';
import wedding28 from './/Wedding28.jpeg';
import wedding29 from './/Wedding29.jpeg';
import wedding30 from './/Wedding30.jpg';
import wedding31 from './/Wedding31.jpg';
import wedding32 from './/Wedding32.jpg';
import wedding33 from './/Wedding33.jpg';
import wedding34 from './/Wedding34.jpg';
import wedding35 from './/Wedding35.jpg';
import wedding36 from './/Wedding36.jpg';
import wedding37 from './/Wedding37.jpg';
import wedding38 from './/Wedding38.jpg';
import wedding39 from './/Wedding39.jpg';
import wedding40 from './/Wedding40.jpg';
import wedding41 from './/Wedding41.jpg';
import wedding42 from './/Wedding42.jpg';
import wedding44 from './/Wedding44.jpg';
import wedding45 from './/Wedding45.jpg';
import wedding46 from './/Wedding46.jpg';
import wedding47 from './/Wedding47.jpg';
import wedding49 from './/Wedding49.jpg';
import wedding50 from './/Wedding50.jpg';
import wedding51 from './/Wedding51.jpg';
import wedding52 from './/Wedding52.jpg';
import wedding53 from './/Wedding53.jpg';
import wedding54 from './/Wedding54.jpg';
import wedding55 from './/Wedding55.jpg';
import wedding58 from './/Wedding58.jpg';
import wedding59 from './/Wedding59.jpg';
import wedding60 from './/Wedding60.jpg';
import wedding61 from './/Wedding61.jpg';
import wedding62 from './/Wedding62.jpg';
import wedding63 from './/Wedding63.jpg';
import wedding64 from './/Wedding64.jpg';
import wedding67 from './/Wedding67.jpg';
import wedding68 from './/Wedding68.jpg';

export interface CustomImage {
  src: string;
  original: string;
  width: number;
  height: number;
}

export const images: CustomImage[] = [
  {
    src: wedding1,
    original: wedding1,
    width: 200,
    height: 200,
  },
  {
    src: wedding2,
    original: wedding2,
    width: 320,
    height: 212,
  },
  {
    src: wedding3,
    original: wedding3,
    width: 320,
    height: 212,
  },
  {
    src: wedding4,
    original: wedding4,
    width: 200,
    height: 213,
  },
  {
    src: wedding5,
    original: wedding5,
    width: 320,
    height: 183,
  },
  {
    src: wedding6,
    original: wedding6,
    width: 300,
    height: 320,
  },
  {
    src: wedding7,
    original: wedding7,
    width: 200,
    height: 200,
  },
  {
    src: wedding8,
    original: wedding8,
    width: 150,
    height: 148,
  },
  {
    src: wedding9,
    original: wedding9,
    width: 320,
    height: 213,
  },
  {
    src: wedding10,
    original: wedding10,
    width: 400,
    height: 320,
  },
  {
    src: wedding11,
    original: wedding11,
    width: 180,
    height: 113,
  },
  {
    src: wedding12,
    original: wedding12,
    width: 313,
    height: 320,
  },
  {
    src: wedding13,
    original: wedding13,
    width: 320,
    height: 213,
  },
  {
    src: wedding14,
    original: wedding14,
    width: 320,
    height: 194,
  },
  {
    src: wedding15,
    original: wedding15,
    width: 320,
    height: 213,
  },
  {
    src: wedding16,
    original: wedding16,
    width: 271,
    height: 320,
  },
  {
    src: wedding17,
    original: wedding17,
    width: 271,
    height: 320,
  },
  {
    src: wedding18,
    original: wedding18,
    width: 271,
    height: 320,
  },
  {
    src: wedding19,
    original: wedding19,
    width: 271,
    height: 320,
  },
  {
    src: wedding20,
    original: wedding20,
    width: 271,
    height: 320,
  },
  {
    src: wedding21,
    original: wedding21,
    width: 271,
    height: 320,
  },
  {
    src: wedding22,
    original: wedding22,
    width: 271,
    height: 320,
  },
  {
    src: wedding23,
    original: wedding23,
    width: 271,
    height: 320,
  },
  {
    src: wedding24,
    original: wedding24,
    width: 271,
    height: 320,
  },
  {
    src: wedding25,
    original: wedding25,
    width: 271,
    height: 320,
  },
  {
    src: wedding26,
    original: wedding26,
    width: 271,
    height: 320,
  },
  {
    src: wedding27,
    original: wedding27,
    width: 271,
    height: 320,
  },
  {
    src: wedding28,
    original: wedding28,
    width: 271,
    height: 320,
  },
  {
    src: wedding29,
    original: wedding29,
    width: 271,
    height: 320,
  },
  {
    src: wedding30,
    original: wedding30,
    width: 300,
    height: 320,
  },
  { src: wedding31, original: wedding31, width: 2400, height: 1600 },
  { src: wedding32, original: wedding32, width: 2400, height: 1600 },
  { src: wedding33, original: wedding33, width: 1600, height: 2400 },
  { src: wedding34, original: wedding34, width: 2400, height: 1600 },
  { src: wedding35, original: wedding35, width: 2400, height: 1600 },
  { src: wedding36, original: wedding36, width: 2400, height: 1600 },
  { src: wedding37, original: wedding37, width: 2400, height: 1600 },
  { src: wedding38, original: wedding38, width: 2400, height: 1600 },
  { src: wedding39, original: wedding39, width: 2400, height: 1600 },
  { src: wedding40, original: wedding40, width: 2400, height: 1600 },
  { src: wedding41, original: wedding41, width: 2400, height: 1600 },
  { src: wedding42, original: wedding42, width: 2400, height: 1600 },
  { src: wedding44, original: wedding44, width: 2400, height: 1600 },
  { src: wedding45, original: wedding45, width: 1600, height: 2400 },
  { src: wedding46, original: wedding46, width: 2400, height: 1600 },
  { src: wedding47, original: wedding47, width: 2400, height: 1600 },
  { src: wedding49, original: wedding49, width: 2400, height: 1600 },
  { src: wedding50, original: wedding50, width: 2400, height: 1600 },
  { src: wedding51, original: wedding51, width: 2400, height: 1600 },
  { src: wedding52, original: wedding52, width: 1600, height: 2400 },
  { src: wedding53, original: wedding53, width: 2400, height: 1600 },
  { src: wedding54, original: wedding54, width: 2400, height: 1600 },
  { src: wedding55, original: wedding55, width: 2400, height: 1600 },
  { src: wedding58, original: wedding58, width: 2400, height: 1600 },
  { src: wedding59, original: wedding59, width: 2400, height: 1600 },
  { src: wedding60, original: wedding60, width: 1600, height: 2400 },
  { src: wedding61, original: wedding61, width: 2400, height: 1600 },
  { src: wedding62, original: wedding62, width: 2400, height: 1600 },
  { src: wedding63, original: wedding63, width: 2400, height: 1600 },
  { src: wedding64, original: wedding64, width: 1600, height: 2400 },
  { src: wedding67, original: wedding67, width: 1600, height: 2400 },
  { src: wedding68, original: wedding68, width: 2400, height: 1600 },
  
];
